module.exports = __webpack_public_path__ + "media/buy-now/bag4-2e8918fc.png";